<nav>
    <a routerLink="/home">Home</a> <br>
    <a routerLink="/mahabharatham">Mahabharatham</a> 
    <a routerLink="/movies">Movies</a> 
  </nav>
  <router-outlet></router-outlet>

